export default "__VITE_ASSET__Cgryg4Mk__"